import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useNavigate } from 'react-router-dom';

function Approval() {
    const navigate = useNavigate();
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [btn, setBtn] = useState({ color: "#04AA6D", text: 'Approve', status: 2 });
    const [loading, setLoading] = useState(false);
    const [isModalBtn, setIsModalBtn] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const pageTitle = 'Approval Requests';
    
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Code',
            dataIndex: 'code',
            key: "code",
            render: (text, record) => record.budget_submission.budget_submission_code,
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: "title",
            render: (text, record) => record.budget_submission.title,
        },
        {
            title: 'User',
            dataIndex: 'user',
            key: "user",
            render: (text, record) => record.budget_submission.user.name,
        },
        {
            title: 'Amount',
            dataIndex: 'price',
            key: "price",
            render: (text, record) => currencyFormat(record.budget_submission.grand_total),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                let statusText, statusColor;
                const id = record.status_approval.status_approval_id;
                if (id === 1) {
                    statusText = 'Pending';
                    statusColor = 'blue';
                } else if (id === 2) {
                    statusText = 'Approved';
                    statusColor = 'green';
                } else {
                    statusText = 'Rejected';
                    statusColor = 'red';
                }
                return (<Tag color={statusColor}>{statusText}</Tag>);
            }
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) =>
                record.created_at !== "" ? moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') : "-",
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <>
                        <Button type="default" style={{ marginRight: 10 }} onClick={() => viewDetail(record)}>
                            <b style={{ marginLeft: 5 }}>View</b>
                        </Button>
                        {
                            record.status_approval.status_approval_id === 1 &&
                            <>
                                <Button type="primary" style={{ marginRight: 10, backgroundColor: "#04AA6D" }} onClick={() => openModal('approve', record)}>
                                    <b style={{ marginLeft: 5 }}>Approve</b>
                                </Button>
                                <Button type="primary" danger style={{ marginRight: 10 }} onClick={() => openModal('reject', record)}>
                                    <b style={{ marginLeft: 5 }}>Reject</b>
                                </Button>
                            </>
                        }
                    </>
                );
            },
        },
    ];

    const viewDetail = (record) => {
        switch (record.budget_submission.status_pay) {
            case "Pengajuan Perjalanan Dinas":
                navigate('/detailperjalanandinas', { state: { item: record } });
                break;
            case "Pengajuan Barang":
                navigate('/detailregular', { state: { item: record } });
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        getApi("GET", `/approval?search=${search}&page=${page.pagination.current}`, 'approval');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setDataModal(null);
                setIsAlert(true);
                setTextAlert(res.message);
                setIsAlert(true);
                form.resetFields();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    };

    const openModal = (type, data) => {
        switch (type) {
            case 'approve':
                setBtn({ color: "#04AA6D", text: 'Approve', status: 2 });
                break;
            case 'reject':
                setBtn({ color: "#f44336", text: 'Reject', status: 3 });
                break;
            default:
                break;
        }
        setDataModal(data);
        setIsModalBtn(true);
    }

    const closeModal = () => {
        setDataModal(null);
        setIsModalBtn(false);
        form.resetFields();
    };

    const onFinish = (values) => {
        const payload = {
            status_approval_id: btn.status,
            desc: values.desc
        };
        postApi("PUT", `/approval/${dataModal.approval_id}`, payload);
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Business Trip Submission Approvals</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} />
            </Row>
            <br />
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal
                title="Submission Approval"
                open={isModalBtn}
                onOk={form.submit}
                onCancel={closeModal}
                okText={btn.text}
                okButtonProps={{ style: { backgroundColor: btn.color } }}
            >
                <Form form={form} name="approval_form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="desc"
                        label="Notes"
                        rules={[{ required: false, message: 'Notes cannot be empty!' }]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Approval;
